module.exports = __webpack_public_path__ + "c27b19de972b8b8255a4a10428ef8019.glb";